var _style, _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "G_Pay_Acceptance_Mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 752 400",
    style: {
      enableBackground: "new 0 0 752 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3C4043;}\n\t.st2{fill:#4285F4;}\n\t.st3{fill:#34A853;}\n\t.st4{fill:#FABB05;}\n\t.st5{fill:#E94235;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Base_1_",
    className: "st0",
    d: "M552,0H200C90,0,0,90,0,200l0,0c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0 C752,90,662,0,552,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    className: "st1",
    d: "M552,16.2c24.7,0,48.7,4.9,71.3,14.5c21.9,9.3,41.5,22.6,58.5,39.5c16.9,16.9,30.2,36.6,39.5,58.5 c9.6,22.6,14.5,46.6,14.5,71.3s-4.9,48.7-14.5,71.3c-9.3,21.9-22.6,41.5-39.5,58.5c-16.9,16.9-36.6,30.2-58.5,39.5 c-22.6,9.6-46.6,14.5-71.3,14.5H200c-24.7,0-48.7-4.9-71.3-14.5c-21.9-9.3-41.5-22.6-58.5-39.5c-16.9-16.9-30.2-36.6-39.5-58.5 c-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7,14.5-71.3c9.3-21.9,22.6-41.5,39.5-58.5c16.9-16.9,36.6-30.2,58.5-39.5 c22.6-9.6,46.6-14.5,71.3-14.5L552,16.2 M552,0H200C90,0,0,90,0,200l0,0c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0 C752,90,662,0,552,0L552,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G_Pay_Lockup_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pay_Typeface_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Letter_p_3_",
    className: "st1",
    d: "M358.6,214.2v60.5h-19.2V125.3h50.9c12.9,0,23.9,4.3,32.9,12.9c9.2,8.6,13.8,19.1,13.8,31.5 c0,12.7-4.6,23.2-13.8,31.7c-8.9,8.5-19.9,12.7-32.9,12.7h-31.7V214.2z M358.6,143.7v52.1h32.1c7.6,0,14-2.6,19-7.7 c5.1-5.1,7.7-11.3,7.7-18.3c0-6.9-2.6-13-7.7-18.1c-5-5.3-11.3-7.9-19-7.9h-32.1V143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Letter_a_3_",
    className: "st1",
    d: "M487.2,169.1c14.2,0,25.4,3.8,33.6,11.4c8.2,7.6,12.3,18,12.3,31.2v63h-18.3v-14.2H514 c-7.9,11.7-18.5,17.5-31.7,17.5c-11.3,0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6,4-19,12-25.2c8-6.3,18.7-9.4,32-9.4 c11.4,0,20.8,2.1,28.1,6.3v-4.4c0-6.7-2.6-12.3-7.9-17c-5.3-4.7-11.5-7-18.6-7c-10.7,0-19.2,4.5-25.4,13.6l-16.9-10.6 C455.2,175.8,469,169.1,487.2,169.1z M462.4,243.3c0,5,2.1,9.2,6.4,12.5c4.2,3.3,9.2,5,14.9,5c8.1,0,15.3-3,21.6-9 s9.5-13,9.5-21.1c-6-4.7-14.3-7.1-25-7.1c-7.8,0-14.3,1.9-19.5,5.6C465,233.1,462.4,237.8,462.4,243.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Letter_y_3_",
    className: "st1",
    d: "M637.5,172.4l-64,147.2h-19.8l23.8-51.5l-42.2-95.7h20.9l30.4,73.4h0.4l29.6-73.4H637.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G_Mark_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Blue_500",
    className: "st2",
    d: "M282.2,202c0-6.3-0.6-12.2-1.6-18h-80.5v33l46.4,0c-1.9,11-7.9,20.3-17.2,26.6V265h27.6 C273,250.1,282.2,228,282.2,202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Green_500_1_",
    className: "st3",
    d: "M229.3,243.6c-7.7,5.2-17.6,8.2-29.1,8.2c-22.4,0-41.3-15.1-48.1-35.4h-28.5v22.1 c14.1,28,43.1,47.2,76.6,47.2c23.1,0,42.6-7.6,56.7-20.7L229.3,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow_500_1_",
    className: "st4",
    d: "M149.4,200c0-5.7,1-11.2,2.7-16.4v-22.1h-28.5c-5.8,11.6-9.1,24.6-9.1,38.5 s3.3,26.9,9.1,38.5l28.5-22.1C150.3,211.3,149.4,205.8,149.4,200z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Red_500",
    className: "st5",
    d: "M200.2,148.3c12.6,0,23.9,4.4,32.9,12.9l24.5-24.4c-14.9-13.8-34.2-22.3-57.3-22.3 c-33.5,0-62.5,19.2-76.6,47.2l28.5,22.1C158.9,163.4,177.8,148.3,200.2,148.3z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.4ebc1e5885be7e7abc968a31bcd6f8ae.svg";
export { ForwardRef as ReactComponent };